import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import vueScroll from "vuescroll";
import { spliceStringPre, sectionToChinese } from "@/libs/tools";
@Component({
    components: {
        vueScroll
    }
})
export default class AiCatalog extends Vue {
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };
    @Prop() readonly catalogs: any;

    mounted() {}
    handleSectionClick(sectionItem: any, chapterItem: any, catalogs: any) {
        this.$emit("handle-section-click", sectionItem, chapterItem, catalogs);
    }

    // 「导读」点击事件
    handleGuideClick(chapterItem) {
        let lastGroup = chapterItem.children[chapterItem.children.length - 1];
        let lastSection = lastGroup.children[lastGroup.children.length - 1];
        this.$emit("handle-guide-click", {
            chapterItem: chapterItem,
            section: lastSection
        });
    }
}

//@ts-ignore
export { default as AiCatalog } from "./index.vue";
